// maomi/src/App.js

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Navigation, { AppRoutes } from './components/Navigation';

const App = () => {
  return (
    <Navigation />
  );
};

export default App;
